import './index.css';

import * as Sentry from '@sentry/react';
import * as serviceWorker from './serviceWorker';

import App from './App';
import { BrowserRouter } from 'react-router-dom';
import React from 'react';
import ReactDOM from 'react-dom';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_SDN,
  environment: process.env.REACT_APP_SENTRY_ENV,
  tracesSampleRate: 1.0
});

const app = (
  // <React.StrictMode>
  <BrowserRouter>
    <App />
  </BrowserRouter>
  // </React.StrictMode>
);

ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
